<template>
  <div v-if="totalPages > 0" class="flex items-center justify-center gap-2">
    <!-- Previous button -->
    <button
      @click="updatePage(currentPage - 1)"
      :disabled="currentPage === 1"
      class="px-3 py-1 rounded-lg border border-primary/20 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-primary/5"
    >
      <Icon name="heroicons:chevron-left" class="w-5 h-5" />
    </button>

    <!-- Rest of the pagination content -->
    <div class="flex gap-1">
      <button
        v-for="page in displayedPages"
        :key="page"
        @click="updatePage(page)"
        :class="[
          'px-3 py-1 rounded-lg',
          currentPage === page
            ? 'bg-primary text-white'
            : 'border border-primary/20 hover:bg-primary/5',
        ]"
      >
        {{ page }}
      </button>
    </div>

    <!-- Next button -->
    <button
      @click="updatePage(currentPage + 1)"
      :disabled="currentPage === totalPages"
      class="px-3 py-1 rounded-lg border border-primary/20 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-primary/5"
    >
      <Icon name="heroicons:chevron-right" class="w-5 h-5" />
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: number;
  total: number;
  perPage: number;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: number): void;
}>();

const currentPage = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const totalPages = computed(() => Math.ceil(props.total / props.perPage));

const displayedPages = computed(() => {
  const pages = [];
  const maxDisplayed = 5;
  let start = Math.max(1, currentPage.value - Math.floor(maxDisplayed / 2));
  let end = Math.min(totalPages.value, start + maxDisplayed - 1);

  if (end - start + 1 < maxDisplayed) {
    start = Math.max(1, end - maxDisplayed + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }
  return pages;
});

const updatePage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};
</script>
